module.exports = __webpack_public_path__ + "media/die.0ed1fed3.mp3";